export enum ETypeSubstrat {
    Bryophytes = 1,
    HydrophytesImm = 2,
    LitieresDebrisVegetaux = 3,
    BranchagesRacines = 4,
    Pierres = 5,
    Blocs = 6,
    Granulats = 7,
    Helophytes = 8,
    Vases = 9,
    SablesLimons = 10,
    Algues = 11,
    DallesMarnes = 12
}
